import { createSelector } from 'reselect';
import { getCasesForPatient } from 'selectors/cases/getCasesForPatient';

export const getCaseForPatient = createSelector(
  getCasesForPatient,
  patientCases => {
    return patientCases?.[0];
  },
);
